import React, { useState } from "react";
import Header from "../../commons/Header/Header";
import Sidebar from "../../commons/Sidebar/Sidebar";
import UploadImg from "../../assets/images/icons/upload-img.svg";
import { useNavigate } from "react-router-dom";
import { handleApiCall } from "../../apis";
import { endpoints } from "../../utils/endpoints";
import { toast } from "react-toastify";
import { Button } from "react-bootstrap";
import { UI_CONSTANTS } from "../../utils/constants";

function AddDriver() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    image: null,
  });
  const [imagePreview, setImagePreview] = useState(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData((prev) => ({
        ...prev,
        image: file,
      }));

      // Create preview
      const reader = new FileReader();
      reader.onload = (e) => {
        setImagePreview(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name.trim()) {
      toast.error("Please enter banner title");
      return;
    }

    if (!formData.description.trim()) {
      toast.error("Please enter banner description");
      return;
    }

    if (!formData.image) {
      toast.error("Please select a banner image");
      return;
    }

    try {
      setLoading(true);
      const submitData = new FormData();
      submitData.append("title", formData.name);
      submitData.append("description", formData.description);
      submitData.append("image", formData.image);

      const response = await handleApiCall("post", endpoints.addBanner, submitData);
      if (response?.data?.code === UI_CONSTANTS.API_CODES.SUCCESS) {
        toast.success("Banner created successfully!");
        setTimeout(() => {
          navigate("/banner-management");
        }, 1000);
      } else {
        toast.error(response?.data?.message || "Failed to create banner");
      }
    } catch (error) {
      console.error("Error creating banner:", error);
      toast.error("Failed to create banner");
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="container-scroller">
      <Header />
      <div className="container-fluid page-body-wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="content-wrapper">
            <div className="heading mb-3 d-flex align-items-center">
              <h3 className="text-default weight-400 my-0">Add Driver</h3>
            </div>

            <div className="mb-4 px-0 py-2">
              <form onSubmit={handleSubmit}>
                <div className="card-heading d-flex align-items-center mb-3 pb-2">
                  <div className="d-flex align-items-center justify-content-start col-md-12 px-0">
                    <Button type="submit" className="rounded-lg" disabled={loading}>
                      {loading ? "Creating..." : "Add"}
                    </Button>
                    <Button type="button" className="rounded-lg ml-4 bg-white" onClick={() => navigate("/driver-managment")} disabled={loading}>
                      Cancel
                    </Button>
                  </div>
                </div>
                <div className="col-md-12 tab-content row px-0 mx-0">
                  <label className="imageUpload" role="button">
                    <input type="file" hidden accept="image/*" onChange={handleImageChange} required />
                    {imagePreview ? (
                      <img src={imagePreview} alt="Preview" style={{ width: "100px", height: "100px", objectFit: "cover" }} />
                    ) : (
                      <>
                        <img src={UploadImg} className="icon" />
                        <div className="text-white mt-1">Upload photo</div>
                      </>
                    )}
                  </label>
                </div>
                <h5 className="text-white mt-4 mb-3">DRIVER DETAILS</h5>
                <div className="row mx-n2">
                  <div className="form-group col-md-4 px-2">
                    <input type="text" className="form-control default" placeholder="Name*" name="" value="" required />
                  </div>
                  <div className="form-group col-md-4 px-2">
                    <input type="text" className="form-control default" placeholder="Mobile number*" name="" value="" required />
                  </div>
                  <div className="form-group col-md-4 px-2">
                    <input type="text" className="form-control default" placeholder="Enter Email Address*" name="" value="" required />
                  </div>
                  <div className="form-group col-md-4 px-2">
                    <select className="form-control default outline-0">
                      <option>Select Country</option>
                      <option>United Kingdom</option>
                      <option>United States</option>
                      <option>United Arab Emi..</option>
                      <option>India</option>
                      <option>Turkey</option>
                    </select>
                  </div>
                  <div className="form-group col-md-4 px-2">
                    <input type="date" className="form-control default" placeholder="" name="" value="" required />
                  </div>
                  <div className="form-group col-md-4 px-2">
                    <input type="text" className="form-control default" placeholder="House/ Flat No*" name="" value="" required />
                  </div>
                  <div className="form-group col-md-4 px-2">
                    <input type="text" className="form-control default" placeholder="Landmark*" name="" value="" required />
                  </div>
                  <div className="form-group col-md-4 px-2">
                    <input type="text" className="form-control default" placeholder="State / Province / Region" name="" value="" required />
                  </div>
                  <div className="form-group col-md-4 px-2">
                    <input type="text" className="form-control default" placeholder="Postal Code / Zip Code / Pincode*" name="" value="" required />
                  </div>
                </div>

                <h5 className="text-white mt-4 mb-3">DRIVER DETAILS</h5>
                <div className="row mx-n2">
                  <div className="form-group col-md-4 px-2">
                    <label className="upload-box">
                      <div>+</div>
                      Upload work permit
                      <input type="file" className="d-none"/>
                    </label>
                  </div>
                  <div className="form-group col-md-4 px-2">
                    <label className="upload-box">
                      <div>+</div>
                      Upload government issued Id
                      <input type="file" className="d-none"/>
                    </label>
                  </div>
                  <div className="form-group col-md-4 px-2">
                    <label className="upload-box">
                      <div>+</div>
                      Upload driver license
                      <input type="file" className="d-none"/>
                    </label>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddDriver;
